import { z } from 'zod';

export const itemScheduleSchema = z.object({
  itemId: z.number().int().positive(),
  expectedStart: z.number().int(),
  expectedFinish: z.number().int(),
  latestFinish: z.number().int(),
});

export type ItemScheduleDTO = z.infer<typeof itemScheduleSchema>;
